<h2 mat-dialog-title>Attenzione</h2>
<mat-dialog-content class="mat-typography">
  <p *ngIf="message">{{ message }}</p>
  <p *ngIf="!message">Nessun documento trovato</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annulla</button>
</mat-dialog-actions>
